import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { OkAloneService } from '../../ok-alone.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CountdownConfig, CountdownEvent, CountdownComponent } from 'ngx-countdown';
import { TERMS_AND_CONDITIONS } from '../../constants/terms-and-conditions';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import Utils from 'src/app/utils';

declare var _: any;
declare var what3words: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  u = Utils;

  workers : any;
  sort:any = 'status';
  monitor:any = 'all';
  group:any = 'all';
  search:any = '';
  status:any = 'all';
  view : any = "full";
  map_vehicle = false;
  map_driver = true;
  pagesize:any = 5;

  timer:any = null;

  groups:any = [];

  config: CountdownConfig = {
    leftTime: 300,
    formatDate: ({ date }) => `${date / 1000}`,
  };

  filter_active = false;

  last_load = 0;

  subscription: any;

  password_change_due: any;

  countSecs = 300;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService,private sanitizer: DomSanitizer) {

    if(this.okService.view.geotab){
      // this.countSecs = 30;
      this.config = {
        leftTime: this.countSecs,
        formatDate: ({ date }) => `${date / 1000}`,
      };
      // console.log(this.config);
    }

    // Set saved values for the home filter
    this.status = localStorage.getItem("home-filter-status") ? localStorage.getItem("home-filter-status") : "all";
    this.group = localStorage.getItem("home-filter-group") ? localStorage.getItem("home-filter-group") : "all";
    this.group = this.group == 'all' ? 'all' : +this.group;
    this.monitor = localStorage.getItem("home-filter-monitor") ? localStorage.getItem("home-filter-monitor") : "all";
    this.sort = localStorage.getItem("home-filter-sort") ? localStorage.getItem("home-filter-sort") : "status";
    this.pagesize = localStorage.getItem("home-filter-pagesize") ? localStorage.getItem("home-filter-pagesize") : 5;
    this.search = localStorage.getItem("home-filter-search") ? localStorage.getItem("home-filter-search") : "";

  }

  showDemoVideo(){
    return !this.okService.isDismissedDb('dash_demo_video1') && this.okService.billing && this.okService.billing.trial_active && this.okService.billing.trial_days <= 5;
  }

  show2fa(){
    return !this.okService.isDismissedDb('2fa_notice') && this.okService.settings.fa2 && !this.okService.session.fa2;
  }

  ngOnInit(): void {
    //console.log("HomeComponent");

    this.pagination.page = 1;
    this.view = localStorage.getItem("home_view") ? localStorage.getItem("home_view") : this.view;

    this.getWorkers();

    // Show terms and conditions modal if needed
    setTimeout(() => {
      if (this.showOrderNowTandCs()) {
        console.log("Show terms and conditions modal");
        const modalElement = document.getElementById('termsModal');
        if (modalElement) {
          const modal = new (window as any).bootstrap.Modal(modalElement);
          modal.show();
        }
      }
    }, 500);

    var _this = this;
    this.timer = setInterval(function(){
      if(_this.view != "map"){
        _this.getWorkers(false);
      }
    }, this.countSecs*1000);

    // Ask permissions to send notifications
    if(!this.okService.notifyPermission()){
      //console.log("notification permission NOT granted");
      this.okService.notifyAsk();
    }else{
      //console.log("notification permission GRANTED");
    }


    this.subscription = this.okService.getWorkerRefreshEmitter()
      .subscribe( ignore_limit => {
        if(this.view!='map'){
          this.getWorkers(ignore_limit);
        }
      } );

    this.password_change_due = this.okService.session.password_change_due;

  }

  ngOnDestroy(): void {

    this.subscription.unsubscribe();

    //console.log("Home Destroyed");
    clearInterval(this.timer);

  }

  // Check the filter options and see if it is active
  isFilterActive(){

    if(this.monitor != 'all' || this.group!= 'all' || this.search != '' || this.status!= 'all'){
      this.filter_active = true;
    }else{
      this.filter_active = false;
    }


  }

  getWorkers(ignore_limit:boolean=true){

    // Limit if done less than 5 seconds ago
    let diff = (new Date()).getTime() - this.last_load;
    let diff_limit = 5000;
    if(ignore_limit){
      diff_limit = 500
    }

    if(diff >= diff_limit){

      this.last_load = (new Date()).getTime();


      let filter = {
        sort: this.sort,
        monitor: this.monitor,
        group: this.group,
        search: this.search,
        status: this.status,
        page: this.pagination.page,
        expand: "status,connectivity,vehicle,message,shift,alert,arc",
        pagesize: this.pagesize
      }

      // console.log('filter',filter);

      this.isFilterActive();

      // Save the home filter options
      localStorage.setItem("home-filter-status",this.status);
      localStorage.setItem("home-filter-group",this.group);
      localStorage.setItem("home-filter-monitor",this.monitor);
      localStorage.setItem("home-filter-sort",this.sort);
      localStorage.setItem("home-filter-pagesize",this.pagesize)
      localStorage.setItem("home-filter-search",this.search);

      this.okService.get("workers/home",filter)
      .subscribe((data) => {



        //this.workers = _.orderBy(data.body, ['status.sort_key'],['desc']);
        this.workers = data.body;
        this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

        this.resetCountdown();

        this.groups = [{id:'all',name:'All Workers'},{id:'none',name:'No Group'}].concat(this.okService.groups);


        // console.log(this.workers);

      });

    }else{
      //console.log("Wait 5 seconds");
    }


  }

  updateFilter(){
        //console.log('filter group', this.formGroup.value);
        this.getWorkers();

  }

  clearFilter(){
    this.monitor = 'all';
    this.group = 'all';
    this.search = '';
    this.status = 'all';
    this.getWorkers();
  }

  manualCheckIn(id:number){

    this.okService.get("workers/ok/"+id,{})
    .subscribe((data) => {

      //console.log(data.body);

      this.getWorkers();

    });

  }

  manualEndShift(id:number){

    this.okService.get("workers/end/"+id,{})
    .subscribe((data) => {

      //console.log(data.body);

      this.getWorkers();

    });

  }

  manualManDown(id:number){

    this.okService.get("workers/mandown/"+id,{})
    .subscribe((data: any) => {
      //console.log(data.body);
      this.getWorkers();
    });

  }

  changeView(view:any){
    this.view = view;

    localStorage.setItem("home_view",view)

    this.getWorkers();

  }

  resetCountdown(){

    this.config = {
      leftTime: this.countSecs,
      formatDate: ({ date }) => `${date / 1000}`,
    };
  }

  whatWords(worker:any){

    let coordinates = worker.status.loc_lat+","+worker.status.loc_lng;

    this.okService.get("account/what3words",{'coordinates':coordinates})
    .subscribe((data:any) => {

      worker.w3w = data.body;

    });

  }

  extendActivity(id:number){

    this.okService.put("activities/extend/"+id,{})
    .subscribe((data:any) => {
      //console.log('extend activity',data);
      this.getWorkers(true);
    });

  }

  completeActivity(id:number){

    this.okService.put("activities/complete/"+id,{})
    .subscribe((data:any) => {
      //console.log('complete activity',data);
      this.getWorkers(true);
    });

  }

  buildMapUrl(map: string): string {
    return map;
  }

  // Show an Order Now Welcome message
  showOrderNowWelcome(){

    if(this.okService.settings && this.okService.settings.geotab && this.okService.settings.order_now && this.okService.billing.trial_active && this.okService.billing.trial_days <= 5){
      return true;
    }
    return false;
  }

  
  showOrderNowTandCs(){

    if(this.okService.settings && this.okService.settings.geotab && this.okService.settings.order_now){
      return !this.okService.isDismissedDb('order_now_tandcs3');
    }

    return false;
  }
  
  getTermsAndConditionsHtml(){
    const termsAndConditions = this.sanitizer.bypassSecurityTrustHtml(TERMS_AND_CONDITIONS);
    return termsAndConditions;
  }

  agreeToTerms(){
    // Hide the modal first
    const modalElement = document.getElementById('termsModal');
    if (modalElement) {
      const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
    
    // Then dismiss the terms and conditions
    this.okService.doDismissDb('order_now_tandcs3');
  }

  /**
   * Show motion heartbeat UI only when the API sent a non-empty last heartbeat time.
   */
  motionHeartbeatVisible(motionHeartbeat: { time?: string | null } | null | undefined): boolean {
    if (!motionHeartbeat) {
      return false;
    }
    return String(motionHeartbeat.time ?? '').trim() !== '';
  }

  /**
   * Label for motion heartbeat badge: activity when known, otherwise "Motion".
   */
  motionHeartbeatLabel(motionHeartbeat: { activity?: string | null } | null | undefined): string {
    if (!motionHeartbeat) {
      return 'Motion';
    }
    const activity = motionHeartbeat.activity;
    if (activity == null || String(activity).trim() === '') {
      return 'Motion';
    }
    const normalized = String(activity).trim().toLowerCase();
    if (normalized === 'unknown') {
      return 'Motion';
    }
    return String(activity).trim();
  }

  /**
   * CoreUI badge color from minutes since last motion heartbeat: fresh, aging, stale.
   */
  motionHeartbeatBadgeColor(minutesSince: number | null | undefined): string {
    const mins = minutesSince == null || Number.isNaN(Number(minutesSince)) ? 999 : Number(minutesSince);
    if (mins < 20) {
      return 'success';
    }
    if (mins < 45) {
      return 'warning';
    }
    return 'danger';
  }
}

